import {Component,OnInit} from '@angular/core';
import { ModalController,NavController } from '@ionic/angular';
import { ChlistmodalPage } from '../chlistmodal/chlistmodal.page';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase} from '@angular/fire/database';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { DragulaService } from 'ng2-dragula';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-topmenu',
  templateUrl: './topmenu.page.html',
  styleUrls: ['./topmenu.page.scss'],
})
export class TopmenuPage implements OnInit {
  subs = new Subscription();
  //channList: { title: string; chid: string; }[];
  currentuid:any;
  favlist:any = [];
  loclan:any;
  menuList: any[] = [];
  channelItems: any[] = [];
  favItems: any[] = [];
  itemIndexof: number;
  mnindex: number;
  scrollable: any;
  removeitem:any[]=[];
  initlist: any[] = [];
  constructor(
    private channlistCtrl: ModalController,
    private route: ActivatedRoute,
    public afAuth: AngularFireAuth,
    public afDB: AngularFireDatabase,
    public navCtrl: NavController,
    private dragulaService: DragulaService
  ) {
    this.loclan = this.route.snapshot.paramMap.get('loclan');
    this.subs.add(this.dragulaService.drag("MENUITEM")
      .subscribe(({ name, el, source }) => {
        this.scrollable = true;
      })
    );
    this.subs.add(this.dragulaService.dragend("MENUITEM")
      .subscribe(({ name, el }) => {
        this.scrollable = false;
      })
    );

    /*
    this.subs.add(this.dragulaService.dropModel("MENUITEM")
      .subscribe(({ name, el, sourceModel, targetModel, sourceIndex, targetIndex, item }) => {
        //console.log(targetModel.splice());
        console.log(sourceIndex, targetIndex)
        this.favlist.splice(sourceIndex,1)
        this.favlist.splice(targetIndex,0,item)
        console.log(this.favlist);
        
      })
    );*/

  }
  
  changestate(item,index){
    this.favlist.splice(index,1);
    var pushed = false;
    if(item.isChecked)
    {
      item.isChecked = false;
      for(let i = 0; i < this.favlist.length; i++)
      {
        if(!this.favlist[i].isChecked)
          {
            this.favlist.splice(i, 0, item);
            pushed = true;
            break;
          }
      }
    }
    else{
      item.isChecked = true;
      item.new = true;
      for(let i = 0; i < this.favlist.length; i++)
      {
        if(!this.favlist[i].isChecked)
          {
            this.favlist.splice(i, 0, item);
            pushed = true;
            break;
          }
      }
    }
    if(!pushed)
      this.favlist.push(item);
  //    item.isChecked? item.isChecked = false : item.isChecked = true
  }

  ngOnInit() {
    this.getdata();
    setTimeout(_=>{
      let today = new Date();
      let todaystr = today.getFullYear() + '-' + (today.getMonth()+1>9?today.getMonth()+1:'0' + (today.getMonth()+1)) + '-' + (today.getDate()>9?today.getDate():'0'+today.getDate())
      this.afDB.database.ref('/systemlog/' + (this.currentuid?this.currentuid:'unregister') + '/event/' + todaystr + '/topmenu').transaction(view=>{
        return (view || 0) + 1;
      })
    },2000)
  }

  getdata() {
   
  }

  savechanges(){
   this.afDB.database.ref('/userData/' + this.currentuid + '/favlist').set(this.favlist);
   this.navCtrl.back();
  }

  resetmenu() {
    this.favlist.forEach(item => {
      item.isChecked = false;
    });
    this.initlist.forEach(inititem=>{
      var chkexist = false;
      for(let i = 0; i < this.favlist.length; i++)
        {
          if(inititem.val.indexOf(this.favlist[i].chid) > -1)
            {
              this.favlist[i].isChecked = true;
              this.favlist[i].customtitle = '';
              chkexist = true;
            }
        }
      if(!chkexist && !inititem.default)
        this.favlist.push({chid:inititem.val.split('/').length>1?inititem.val.split('/')[1]:inititem.val, title:inititem.name, isChecked:true, updateDate:new Date().getTime()})    
    })
  }

  editname(item, ip) {
    //console.log(ip);
    if(item.editmode) {
      item.editmode = false;
    } else {
      item.editmode = true;
      setTimeout(_=>{ip.setFocus()},50);
    }
  }
  confirmName(item, event): void {
    if(event.keyCode === 13) {
      // console.log('Enter key pressed');
      item.editmode = false;
    }
  }

  async openChannList() {
    const modal = await this.channlistCtrl.create({
      component: ChlistmodalPage,
      componentProps:<null> {favlist:this.favlist},
      cssClass: 'ph-custom-modal'
    });
    modal.onDidDismiss().then(rst=>{
      
      if(rst.data)
      {
       // this.favlist = rst.data.favlist;
       console.log(rst.data);
      }
    })
    return await modal.present();
  }

  


  


}